module.exports = __webpack_public_path__ + "img/about.c3700220.jpg";